const TURKEY_LAT_RANGE = [35, 43];
const TURKEY_LNG_RANGE = [25, 46];

const inRange = (value, range) =>
  Number.isFinite(value) && value >= range[0] && value <= range[1];

const parseNumericText = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const text = String(value).trim().replace(",", ".");
  if (!text) return null;
  const direct = Number(text);
  return { text, direct };
};

export const normalizeCoordinateNumber = (value, type) => {
  const parsed = parseNumericText(value);
  if (!parsed) return undefined;

  const targetRange = type === "lng" ? TURKEY_LNG_RANGE : TURKEY_LAT_RANGE;
  if (inRange(parsed.direct, targetRange)) return parsed.direct;

  const sign = parsed.text.trim().startsWith("-") ? -1 : 1;
  const digits = parsed.text.replace(/[^\d]/g, "");
  if (!digits || digits.length < 4) return undefined;

  for (let scale = 1; scale <= 8; scale += 1) {
    const candidate = sign * (Number(digits) / (10 ** scale));
    if (inRange(candidate, targetRange)) return candidate;
  }

  return undefined;
};

export const normalizeCoordinateString = (value, type) => {
  const number = normalizeCoordinateNumber(value, type);
  return Number.isFinite(number) ? number.toFixed(6) : "";
};
